<main class="about-us">
  <!-- Hero Section -->
  <section class="hero">
    <div class="overlay"></div>
    <div class="content">
      <h1>About Heattech</h1>
      <p>Innovating plumbing solutions since our inception.</p>
    </div>
  </section>

  <!-- Our Story -->
  <section class="story container">
    <div class="text">
      <h2>Our Story</h2>
      <p>
        Heattech started in a small workshop back in 2010, driven by a passion
        for energy-efficient plumbing and sustainable design. Over the years,
        we've grown into a leading name, blending cutting-edge technology with
        exceptional craftsmanship.
      </p>
    </div>
    <div class="image">
      <img src="/images/early-days.jpg" alt="Early days at Heattech workshop" />
    </div>
  </section>

  <!-- Mission & Values -->
  <section class="mission-values container">
    <div class="cards">
      <div class="card">
        <h3>Our Mission</h3>
        <p>
          To deliver innovative and sustainable plumbing solutions that enhance
          comfort, conserve resources, and drive industry forward.
        </p>
      </div>
      <div class="card">
        <h3>Our Values</h3>
        <ul>
          <li>Integrity</li>
          <li>Innovation</li>
          <li>Quality</li>
          <li>Sustainability</li>
        </ul>
      </div>
    </div>
  </section>

  <!-- Team Section -->
  <section class="team container">
    <h2>Meet the Team</h2>
    <div class="team-grid">
      <div class="member-card" *ngFor="let person of team">
        <img [src]="person.photo" [alt]="person.name" />
        <h4>{{ person.name }}</h4>
        <p>{{ person.role }}</p>
      </div>
    </div>
  </section>
</main>
